import { FC } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { HotelResource } from "../../../shared/types/hotel";
import { ButtonCard, ButtonCardBaseIcon, ButtonCardBody, ButtonCardIcon, ButtonCardIconRow } from "./ButtonCard";
import { HotelImage } from "./HotelImage";
import { HotelInfoDrawer } from "./HotelnfoDrawer";

interface Props {
	hotel: HotelResource;
	isSelected: boolean;
	onSelect: () => void;
	disabled?: boolean;
}

const Address = styled.address`
	font-style: inherit;
`;

const Url = styled.a`
	font-weight: ${({ theme }) => theme.fonts.weights.normal};
`;

export const HotelCard: FC<Props> = ({ hotel, isSelected, onSelect, disabled = false }) => {
	const { t } = useTranslation();
	return (
		<ButtonCard
			disabled={disabled}
			role="button"
			aria-label={hotel.name}
			aria-pressed={isSelected}
			onClick={onSelect}
			tabIndex={0}
		>
			<HotelImage image={hotel.image} />
			<ButtonCardBody>
				<strong>{hotel.name}</strong>
				{(hotel.street || hotel.zip || hotel.city || hotel.country) && (
					<ButtonCardIconRow>
						<ButtonCardBaseIcon src="/icons/pin_drop.svg" />
						<Address>
							{hotel.street && <div>{hotel.street}</div>}
							{hotel.zip && <div>{hotel.zip}</div>}
							{hotel.city && <div>{hotel.city}</div>}
							{hotel.country && <div>{hotel.country}</div>}
						</Address>
					</ButtonCardIconRow>
				)}
				{hotel.infoPageId && (
					<ButtonCardIconRow>
						<ButtonCardIcon $icon="info" />
						<HotelInfoDrawer blockId={hotel.infoPageId} />
					</ButtonCardIconRow>
				)}
				{hotel.url && (
					<ButtonCardIconRow>
						<ButtonCardIcon $icon="external_link" />
						<Url href={hotel.url} target="_blank" rel="noreferrer">
							{t("Open website")}
						</Url>
					</ButtonCardIconRow>
				)}
			</ButtonCardBody>
		</ButtonCard>
	);
};
